<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="17" y="25" width="66" height="50" stroke="black" stroke-width="4"/>
<path d="M17 25L50 57.6923L83 25" stroke="black" stroke-width="4"/>
</svg>

</template>
